module.exports = __webpack_public_path__ + "img/logo.52e20ba0.svg";